import React from 'react';
import { Typography, TypographyProps, useTheme } from '@mui/material';

interface GradientTextProps extends Omit<TypographyProps, 'color'> {
  children: React.ReactNode;
}

/**
 * Typography component with gradient text effect
 * Uses primary (coral) to secondary (purple) gradient
 */
export const GradientText: React.FC<GradientTextProps> = ({ children, sx, ...props }) => {
  const theme = useTheme();

  return (
    <Typography
      {...props}
      sx={{
        background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
};
